import {Injectable} from "@angular/core";
import {AbstractCacheService} from "./abstract.cache.service";
import {ApiResponse} from "../models/api_response.entity";

@Injectable({
    providedIn: 'root'
})
export class GenericCacheService extends AbstractCacheService<any> {
}